import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { ADVISOR_OPPORTUNITY_COUNTS } from '@src/gql/queries/AdvisorOpportunities';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
type CountsCollection = {
  pagination?: {
    itemCount?: number | null;
  } | null;
} | null;
type OpportunityCountsData = {
  invited?: CountsCollection;
  active?: CountsCollection;
  matched?: CountsCollection;
  applied?: CountsCollection;
};
export type OpportunityCounts = {
  invited: number;
  applied: number;
  matched: number;
  active: number;
};
const countOf = (collection: CountsCollection) => Number(collection?.pagination?.itemCount ?? 0);

/**
 * Badge counts for the Opportunities sub-nav rail.
 *
 * One `pageSize: 1` query for rail totals — the section pages stay responsible
 * for fetching their own lists.
 */
export const useOpportunityCounts = () => {
  const $ = _c(19);
  const {
    currentUser
  } = useCurrentUser();
  const t0 = !currentUser?.isRegistered;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      skip: t0,
      fetchPolicy: "cache-and-network"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const query = useQuery(ADVISOR_OPPORTUNITY_COUNTS, t1);
  const t2 = query.data?.invited;
  let t3;
  if ($[2] !== t2) {
    t3 = countOf(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = query.data?.applied;
  let t5;
  if ($[4] !== t4) {
    t5 = countOf(t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = query.data?.matched;
  let t7;
  if ($[6] !== t6) {
    t7 = countOf(t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = query.data?.active;
  let t9;
  if ($[8] !== t8) {
    t9 = countOf(t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t7 || $[13] !== t9) {
    t10 = {
      invited: t3,
      applied: t5,
      matched: t7,
      active: t9
    };
    $[10] = t3;
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const counts = t10;
  const t11 = query.loading && !query.data;
  let t12;
  if ($[15] !== counts || $[16] !== query.refetch || $[17] !== t11) {
    t12 = {
      counts,
      loading: t11,
      refetch: query.refetch
    };
    $[15] = counts;
    $[16] = query.refetch;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};